import { Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import i18nMap from 'src/mapping/i18nMap.json';
import { useDashboardServicesStore } from 'src/models/useDashboardServicesModel';
import { generateRedirectUrlToLog } from 'src/pages/Log/shared';
import { getServiceNamesByValues } from 'src/utils/service';
import { formatTableTopX, replaceTableData } from 'src/utils/table';

import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import RedirectLink from '@Components/RedirectLink';
import { LogTypeEnum, SecurityFilterName } from '@Types/log';

function SecurityRiskFileBlocking(props: { data: any; day: string }) {
  const { t } = useTranslation();
  const servicesModel = useDashboardServicesStore();

  const config = [
    { width: '50%', grow: 1, align: 'left', tooltip: true },
    { width: '30%', grow: 0, align: 'right' },
  ];
  const header = [
    t('dashboard.chart.column.fileType'),
    t('dashboard.chart.column.files'),
  ];

  const fileBlockingTypeMap = new Map<string, string>(
    Object.entries(i18nMap['fileBlockingType'].frontendMap)
  );

  const data = formatTableTopX(
    props.data?.security_risk_scanFileBlockingByType?.[props.day],
    ['key', 'doc_count'],
    t
  ).map((row) => [
    row[0],
    row[1] === 0 ? (
      0
    ) : (
      <RedirectLink
        href={`logs?${generateRedirectUrlToLog(
          [
            {
              field: 'securityFilterName',
              values: [SecurityFilterName.FileBlocking],
              type: 'terms',
            },
            {
              field: 'fileType',
              values: [row[0] as string],
              type: 'terms',
            },
            {
              field: 'scanSource',
              values: getServiceNamesByValues(servicesModel.enabledServices),
              type: 'terms',
            },
          ],
          props.day,
          LogTypeEnum.DETECTION
        )}`}
      >
        <Text>{row[1]}</Text>
      </RedirectLink>
    ),
  ]);
  replaceTableData(data, fileBlockingTypeMap, 0, t);

  return (
    <DashboardCard
      height="324px"
      title={t('dashboard.chart.title.atpFileBlocking')}
    >
      <TableTemplate config={config} header={header} data={data} />
    </DashboardCard>
  );
}

export default React.memo(SecurityRiskFileBlocking);
